export default function NewsLeafDropOff() {
    return (
        <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button caret-off collapsed " type="button" data-bs-toggle="collapse" data-bs-target="#collapseNewsLeafDropOff">
            <i className="fa-brands fa-envira fa-2xl feature-icon af-icon"></i>
            <b>2026 Leaf Drop-Off:<br/> November 7th - December 13th</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span className="badge text-bg-success">NOTICE</span>
          </button>
        </h2>
        <div id="collapseNewsLeafDropOff" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
          <div className="accordion-body">

    <p>
          Leaf drop off, located at Delaware & Riverview Avenues, will be open starting November 7th and running through December 13th.<br/>

<strong>Hours:<br/>
Mon. - Fri. 8:00 a.m. to 3:00 p.m.<br/>
Sat. &amp; Sun. 8:00 a.m. to 2:00 p.m. <br/>
</strong>

<font color="red">Open to Morrisville Borough residents only.</font>
</p>




<p>  <a href="../img/flyers/flyer-2026-leaf-dumping.png" target="_blank" alt="flyer for 2026 leaf dumping">
            <img
              className="accordion-image-responsive"
              src="../img/flyers/flyer-2026-leaf-dumping.png"
              alt="flyer for 2026 leaf dumping"
              onclick="this.requestFullscreen()"
            />
            <br />
            <i className="fa-solid fa-magnifying-glass-plus fa-xl"></i>
            &nbsp;&nbsp;Click to enlarge this image 
          </a>
          </p>
          </div>
        </div>
      </div>
    )
}